module.exports = __webpack_public_path__ + "static/img/s5.77e7232.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/custom/s5.png
// module id = +uPn
// module chunks = 0